module.exports = __webpack_public_path__ + "img/svg/xbox-one.ae7125af044765e931c8239650a787cb.svg";